import { PaneArea, ResizeByThumbFuncProps, ThumbType } from '../../types/shared'
import PaneModel from '../models/pane'

type Area = PaneArea
type ResizeFunc = (props: ResizeByThumbFuncProps) => void
type ScaleFunc = () => number

interface RenderOpts {
  isActive?: boolean
  isHover?: boolean
}

class Thumb {
  type: ThumbType
  lastX = 0
  lastY = 0
  fx: ScaleFunc
  fy: ScaleFunc
  resize: ResizeFunc
  model: PaneModel

  constructor(type: ThumbType, fx: ScaleFunc, fy: ScaleFunc, resize: ResizeFunc, model: PaneModel) {
    this.type = type
    this.fx = fx
    this.fy = fy
    this.resize = resize
    this.model = model
  }

  render(context: CanvasRenderingContext2D, { isActive, isHover }: RenderOpts = {}) {
    const { ThumbSettings, ChartSettings } = this.model.getChartLayoutSettings()

    context.beginPath()
    context.fillStyle = ChartSettings.general.Colors.canvasFill
    context.strokeStyle = ThumbSettings.borderColor
    context.lineWidth = ThumbSettings.borderWidth

    if (isActive || isHover) {
      context.strokeStyle = ThumbSettings.borderColorActive
    }

    const x = ~~this.x()
    const y = ~~this.y()
    const thumbHalf = this.getThumbWidth().baseWidth / 2
    const mod = ThumbSettings.borderWidth % 2
    const offset = ~~(mod ? mod : 1)
    context.ellipse(x + offset + thumbHalf, y + offset + thumbHalf, thumbHalf, thumbHalf, 0, 0, 2 * Math.PI)
    context.fill()
    context.stroke()
    context.closePath()
  }

  startEditing(area: Area) {
    this.lastX = area.x
    return (this.lastY = area.y)
  }

  moveTo(area: Area) {
    const difX = area.x - this.lastX
    const difY = area.y - this.lastY
    this.resize({ type: this.type, difX, difY, area })
    this.lastX = area.x
    this.lastY = area.y
  }

  isInArea(area: Area) {
    const { scale } = this.model
    const { hitboxWidth } = this.getThumbWidth()
    const width = scale.x.invert(hitboxWidth)
    const height = scale.y.invert(0) - scale.y.invert(hitboxWidth)

    // +- width/2 because we have coordinates of a center
    const halfWidth = width / 2
    const halfHeight = height / 2
    const x = this.fx()
    const y = this.fy()

    return x + halfWidth >= area.x && x - halfWidth <= area.x && y + halfHeight > area.y && y - halfHeight < area.y
  }

  getThumbWidth() {
    const { ThumbSettings } = this.model.getChartLayoutSettings()
    const baseWidth = ThumbSettings.size
    const fullWidth = baseWidth + ThumbSettings.borderWidth * 2
    const hitboxWidth = fullWidth + ThumbSettings.hitboxOffset * 2
    return { baseWidth, fullWidth, hitboxWidth }
  }

  x() {
    const { ThumbSettings } = this.model.getChartLayoutSettings()
    return this.model.scale.x(this.fx()) - ThumbSettings.size / 2
  }

  y() {
    const { ThumbSettings } = this.model.getChartLayoutSettings()
    return this.model.scale.y(this.fy()) - ThumbSettings.size / 2
  }
}

export default Thumb
